import React from 'react';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';

import { ModalWrapper, CloseButton, ModalDescription, SignInButton } from './styles';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';

export function SuccessModal({ isModalOpen, handleClose }) {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
      aria-labelledby="success-modal-title"
      aria-describedby="success-modal-description"
      disableBackdropClick 
    >
      <ModalWrapper>
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
        <ModalDescription id="success-modal-description">
          <DoneIcon style={{ fontSize: 50, color: '#47A150' }} />
          <br />
          Senha redefinida com sucesso!
        </ModalDescription>
        <SignInButton type="button" onClick={() => { 
          dispatch({ type: "SET_STEP", step: 0 });
          history.push('/acessar')
        }}>
          <span> Fazer login com nova senha</span>
        </SignInButton>
      </ModalWrapper>
    </Modal>
  );
}
